import React from 'react';
import PropTypes from 'prop-types';

import { leadTimeTitle } from '../messages/pdpBlurbMessages';

import styles from './PdpSharedLeadTime.scss';

export function PdpSharedLeadTime({ leadTime }) {
    return (
        <React.Fragment>
            <span className={styles.label}>{leadTimeTitle}</span>
            <span className={styles.value}>{leadTime}</span>
        </React.Fragment>
    );
}

PdpSharedLeadTime.propTypes = {
    leadTime: PropTypes.string,
};
